import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Forbidden } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import { RightsContext } from 'providers/RightsContext';
import { usePermissions } from 'providers/RightsHooks';

const PermissionCheck = ({ authorizationCode, children, withForbiddenPage }) => {
  const { t } = useTranslation();
  const hasPermission = usePermissions(Array.isArray(authorizationCode) ? authorizationCode : [authorizationCode]);
  const { loaded } = useContext(RightsContext);

  return loaded && hasPermission ? (
    <>{children}</>
  ) : loaded === false ? (
    <></>
  ) : withForbiddenPage ? (
    <Forbidden forbiddenText={t('General.NoPermission')} />
  ) : (
    <></>
  );
};

PermissionCheck.defaultProps = {
  withForbiddenPage: true
};

PermissionCheck.propTypes = {
  authorizationCode: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  children: PropTypes.node,
  withForbiddenPage: PropTypes.bool
};

export default PermissionCheck;
